import PropTypes from "prop-types";
import { moneyWithoutDecimals } from "helpers/formatting";
import ChatButton from "components/shared/adventures/ChatButton";
import Title from "components/residency/Title";
import Text from "components/residency/Text";
import Departure from "components/wsl/Departure";
import styles from "components/event/PanelAvailability.module.scss";

export default function PanelAvailability({ departures }) {
  return (
    <div className={styles.component}>
      <Title size="lg" className={styles.title}>
        Availability
      </Title>
      <div size="sm" className={styles.pricing}>
        <span className={styles.price}>
          From{" "}
          {moneyWithoutDecimals(
            Math.min(...departures.map((departure) => departure.price))
          )}
        </span>{" "}
        / person
      </div>
      <div className={styles.text}>
        <Text size="sm">
          Want to learn more about the trip or ask questions? We&apos;d love to
          chat. <ChatButton type="text-only" text="Shoot us a message" />
        </Text>
      </div>
      <div className={styles.departures}>
        {departures
          .filter((departure) => departure.quantity_available > 0)
          .map((departure) => (
            <Departure
              key={departure.id}
              variantID={departure.id}
              spotsLeft={departure.quantity_available}
              noAccommodations={departure.no_accommodations}
            />
          ))}
      </div>
      <div className={styles.departures}>
        {departures
          .filter((departure) => departure.quantity_available === 0)
          .map((departure) => (
            <Departure
              key={departure.id}
              variantID={departure.id}
              startDate={departure.start_date}
              endDate={departure.end_date}
              spotsLeft={departure.quantity_available}
            />
          ))}
      </div>
    </div>
  );
}

PanelAvailability.propTypes = {
  departures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      start_date: PropTypes.string,
      end_date: PropTypes.string,
      total_quantity: PropTypes.number,
      quantity_available: PropTypes.number,
    })
  ),
};
